var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisaoGeral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2388_5204",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2388_5204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99643 21.0048H9.17143V13.3002H14.8286V21.0048H20.0036V8.99839L12 2.96308L3.99643 8.99839V21.0048ZM3.99643 22C3.71786 22 3.48214 21.9037 3.28929 21.7111C3.09643 21.5185 3 21.283 3 21.0048V8.99839C3 8.84858 3.03214 8.70412 3.09643 8.56501C3.16071 8.4259 3.25714 8.31354 3.38571 8.22793L11.4214 2.16051C11.5071 2.09631 11.5982 2.0535 11.6946 2.0321C11.7911 2.0107 11.8929 2 12 2C12.1071 2 12.2089 2.0107 12.3054 2.0321C12.4018 2.0535 12.4929 2.09631 12.5786 2.16051L20.6143 8.22793C20.7429 8.31354 20.8393 8.4259 20.9036 8.56501C20.9679 8.70412 21 8.84858 21 8.99839V21.0048C21 21.283 20.9036 21.5185 20.7107 21.7111C20.5179 21.9037 20.2821 22 20.0036 22H13.8321V14.2953H10.1679V22H3.99643Z",
    fill: "#58C5C6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaoGeral);
export default __webpack_public_path__ + "static/media/visao_geral.601688d15452e2fa7b8387f81893e7de.svg";
export { ForwardRef as ReactComponent };